<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="35%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="选择机构"
          prop="agencyId"
        >
          <el-select
            v-model="createForm.agencyId"
            filterable
            clearable
            placeholder="请选择机构"
          >
            <el-option
              v-for="course in agencyList"
              :key="course.id"
              :label="course.value"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'Orderdialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    courseRegistrationId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      title: '修改机构',
      createForm: {
        courseRegistrationId: null,
        agencyId: null,
      },
      creatRules: {
        agencyId: [
          { required: true, message: '请选择机构', trigger: 'change' },
        ],
      },
      agencyList: [],
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
          this.$refs.createForm.resetFields();
        });
      }
    },
  },
  mounted() {
    this.getAgencyList();
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.order.updateCourseRegistrationAgency({
            courseRegistrationId: this.courseRegistrationId,
            agencyId: this.createForm.agencyId,
          });
          if (!data) return;
          this.$message.success('修改机构成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
    async getAgencyList() {
      this.agencyList = await axClient.common.agencyListName();
    },
  },
};
</script>
